import React from "react";
import styles from "./style.module.css";
import { Box } from "@mui/material";
import { useTheme } from "../../../../../../../context/themeContext";

const Alert = (props) => {
  const { theme } = useTheme();
  const { type } = props;

  return (
    <React.Fragment>
      {(() => {
        switch (type) {
          case "complete":
            return (
              <Box
                className={styles.alert}
                sx={{
                  border: "1px solid",
                  borderColor: "#FFF",
                  background: theme.palette.success.dark,
                }}
              ></Box>
            );
          case "notComplete":
            return (
              <Box
                className={styles.alert}
                sx={{
                  border: "1px solid",
                  borderColor: "#FFF",
                  background: theme.palette.danger.red500,
                }}
              ></Box>
            );
          case "notAdded":
            return <></>;
          default:
            return null;
        }
      })()}
    </React.Fragment>
  );
};

export default Alert;
